<template>
  <div class="login-wrapper d-flex align-items-center justify-content-center min-vh-100">
    <!-- Background Overlay -->
    <div class="bg-overlay"></div>

    <!-- Login Card -->
    <div class="login-card p-5 shadow-lg">
      <div class="text-center mb-4">
        <img src="@/assets/images/logo_owner.png" alt="Logo" class="logo mb-3" />
        <h2 class="fw-bold">Bienvenue</h2>
        <p class="text-muted">Connectez-vous pour continuer</p>
      </div>

      <!-- Error Message -->
      <div v-if="error" class="alert alert-danger text-center">{{ error }}</div>

<!-- Form -->
<b-form @submit.prevent="onSubmit" class="fancy-form w-100" style="max-width: 400px; margin: 0 auto;">
  
  <!-- Email -->
  <b-form-group class="mb-4">
    <b-input-group>
      <b-input-group-prepend is-text>
        <img
          src="@/assets/icons/profile.svg"
          style="width: 20px; height: 20px; margin-right: 6px;"
          draggable="false"
          alt="profile"
        />
      </b-input-group-prepend>
      <b-form-input
        id="email"
        v-model="model.email"
        type="text"
        placeholder="E-mail"
        required
      ></b-form-input>
    </b-input-group>
  </b-form-group>

  <!-- Password -->
  <b-form-group class="mb-4">
    <b-input-group>
      <b-input-group-prepend is-text>
        <img
          src="@/assets/icons/password.svg"
          style="width: 25px; height: 25px;"
          draggable="false"
          alt="password"
        />
      </b-input-group-prepend>
      <b-form-input
        id="password"
        v-model="model.password"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Mot de passe"
        required
      ></b-form-input>
      <b-input-group-append is-text @click="togglePasswordVisibility">
        <img
          v-if="showPassword"
          src="@/assets/icons/eye-off.svg"
          alt="Hide password"
          height="20"
          class="m-0"
        />
        <img
          v-else
          src="@/assets/icons/eye.svg"
          alt="Show password"
          height="20"
          class="m-0"
        />
      </b-input-group-append>
    </b-input-group>
  </b-form-group>

  <!-- Remember Me & Forgot -->
  <!--b-form-group class="mb-2">
    <b-form-checkbox v-model="model.rememberMe" class="w-100">
      Se souvenir de moi
    </b-form-checkbox>
  </b-form-group>

  <b-form-group class="mb-4">
    <a href="#" class="text-decoration-none d-block text-center w-100">Mot de passe oublié ?</a>
  </b-form-group-->

  <!-- Submit Button -->
  <b-button type="submit" variant="primary" block :disabled="isLoading" class="py-2 fw-bold">
    <b-spinner small v-if="isLoading"></b-spinner>
    <span v-else>Se Connecter</span>
  </b-button>
</b-form>


      <!-- Footer -->
      <div class="text-center mt-4 text-muted">
        Powered by <a href="https://tufratech.com/" class="text-primary fw-bold">TufraTech</a>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/utilsAuth";

export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
      error: "",
      isLoading: false,
      showPassword: false,
    };
  },
  methods: {
    onSubmit() {
      this.handleLogin();
    },
    async handleLogin() {
      this.isLoading = true;
      this.error = "";
      try {
        await login(this.model.email, this.model.password);
        this.$router.push("/ocr");
      } catch (e) {
        this.error = "Email ou mot de passe incorrect.";
      } finally {
        this.isLoading = false;
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
/* Wrapper & Background */
.login-wrapper {
  position: relative;
 background: linear-gradient(135deg, #e1dac8 0%, #eee0be 100%);

}

.bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 1;
}

/* Login Card */
.login-card {
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  max-width: 400px;
  width: 90%;
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
}

.logo {
  width: 160px;
}

/* Inputs */
.b-form-input, .b-button {
  border-radius: 10px;
}

.b-form-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(37, 117, 252, 0.25);
}

/* Buttons */
.b-button-primary {
  background: #2575fc;
  border: none;
  transition: background 0.3s ease;
}

.b-button-primary:hover {
  background: #1a5ed8;
}

/* Misc */
.text-muted {
  font-size: 0.9rem;
}
</style>
